export interface tag {
    name: string;
    friendlyName: string;
    type: "Standard" | "Smart" | "Skin" | "MIS" | "Error";
}

let allTags: Array<tag> = [
    {
        name: "[#REFERENCE]",
        friendlyName: "Enquiry Reference",
        type: "Standard",
    },
    {
        name: "[#DATE_SENT]",
        friendlyName: "Date Enquiry Sent",
        type: "Standard",
    },
    {
        name: "[#DATE_SENT_FULL]",
        friendlyName: "Date & Time Enquiry Sent",
        type: "Standard",
    },
    {
        name: "[#DATE_RECEIVED]",
        friendlyName: "",
        type: "Standard",
    },
    {
        name: "[#DATE_RECEIVED_FULL]",
        friendlyName: "Date Enquiry Received",
        type: "Standard",
    },
    {
        name: "[#DATE]",
        friendlyName: "Date",
        type: "Standard",
    },
    {
        name: "[#TIME]",
        friendlyName: "Time",
        type: "Standard",
    },
    {
        name: "[#DATE_TIME]",
        friendlyName: "Date & Time",
        type: "Standard",
    },
    {
        name: "[#USER]",
        friendlyName: "Logged User",
        type: "Standard",
    },
    {
        name: "[#USER_FIRSTNAME]",
        friendlyName: "Logged User Firstname",
        type: "Standard",
    },
    {
        name: "[#USER_LASTNAME]",
        friendlyName: "Logged User Lastname",
        type: "Standard",
    },
    {
        name: "[#MAILBOX_ADDRESS]",
        friendlyName: "Mailbox Address",
        type: "Standard",
    },
    {
        name: "[#MAILBOX_NAME]",
        friendlyName: "Mailbox Name",
        type: "Standard",
    },
    {
        name: "[#MAILBOX_TELEPHONE]",
        friendlyName: "Mailbox Telephone",
        type: "Standard",
    },
    {
        name: "[#MAILBOX_FACSIMILE]",
        friendlyName: "Mailbox Facsimile",
        type: "Standard",
    },
    {
        name: "[#ENQUIRER_NAME]",
        friendlyName: "Enquirer Name",
        type: "Standard",
    },
    {
        name: "[#ENQUIRER_ADDRESS]",
        friendlyName: "Enquirer Address",
        type: "Standard",
    },
    {
        name: "[#ENQUIRER_SUBJECT]",
        friendlyName: "Enquirer Subject",
        type: "Standard",
    },
    {
        name: "[#USER_TELEPHONE]",
        friendlyName: "Logged User Telephone",
        type: "Standard",
    },
    {
        name: "[#USER_FACSIMILE]",
        friendlyName: "Logged User Facsimile",
        type: "Standard",
    },
    {
        name: "[#USER_MOBILE]",
        friendlyName: "Logged User Mobile",
        type: "Standard",
    },
    {
        name: "[#USER_ADDRESS]",
        friendlyName: "Logged User Address",
        type: "Standard",
    },
    {
        name: "[#USER_PROFILE_EMAIL]",
        friendlyName: "Logged User Profile Email",
        type: "Standard",
    },
    {
        name: "[#USER_PROFILE_JOBTITLE]",
        friendlyName: "Logged User Profile Job Title",
        type: "Standard",
    },
    {
        name: "[#CURSOR]",
        friendlyName: "Cursor position for editing",
        type: "Standard",
    },
    {
        name: "",
        friendlyName: "------------------------------------------------------",
        type: "Standard",
    },
    {
        name: "[#SKIN_KEY 0]",
        friendlyName: "Skin Override",
        type: "Skin",
    },

    {
        name: "[#USER_CUSTOM Name Default_Value]",
        friendlyName: "User Custom Tag",
        type: "Skin",
    },

    {
        name: "[#MIS_VALUE 0]",
        friendlyName: "MIS Tagg",
        type: "MIS",
    },

    {
        name: '[#tag id="FEEDBACK_DATE_TIME" caption="Feedback Promise" value="" type="datetime"]',
        friendlyName: "Smart Feedback",
        type: "Smart",
    },

    {
        name: '[#tag id="" caption="" value="" type=""]',
        friendlyName: "Smart ",
        type: "Smart",
    },

    {
        name: '[#tag id="" caption="" value="" type="date"]',
        friendlyName: "Smart Date",
        type: "Smart",
    },

    {
        name: '[#tag id="" caption="" value="" type="time"]',
        friendlyName: "Smart Time",
        type: "Smart",
    },

    {
        name: '[#tag id="" caption="" value="" type="dropdown"]',
        friendlyName: "Smart Text",
        type: "Smart",
    },

    {
        name: '[#tag id="" caption="" value="" type="dropdown" value0=""]',
        friendlyName: "Smart Dropdown",
        type: "Smart",
    },
    {
        name: "",
        friendlyName: "------------------------------------------------------",
        type: "Smart",
    },
    {
        name: '[#tag id="" caption="" value="" type="numeric"]',
        friendlyName: "Smart Numeric",
        type: "Smart",
    },
    {
        name: '[#tag id="" caption="" value="R" type="currency"]',
        friendlyName: "Smart Currency",
        type: "Smart",
    },
];

export function getTags(): tag[] {
    return allTags;
}
